import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemovePartnerAccountFromInvoiceCollectionMutationVariables = Types.Exact<{
  invoiceCollectionId: Types.Scalars['ID'];
  partnerAccountId: Types.Scalars['ID'];
}>;


export type RemovePartnerAccountFromInvoiceCollectionMutation = { __typename?: 'Mutation', removePartnerAccountFromInvoiceCollection?: { __typename?: 'InvoiceCollection', id: string, partner_account_ids?: Array<string | null> | null } | null };


export const RemovePartnerAccountFromInvoiceCollectionDocument = gql`
    mutation RemovePartnerAccountFromInvoiceCollection($invoiceCollectionId: ID!, $partnerAccountId: ID!) {
  removePartnerAccountFromInvoiceCollection(
    invoice_collection_id: $invoiceCollectionId
    partner_account_id: $partnerAccountId
  ) {
    id
    partner_account_ids
  }
}
    `;
export type RemovePartnerAccountFromInvoiceCollectionMutationFn = Apollo.MutationFunction<RemovePartnerAccountFromInvoiceCollectionMutation, RemovePartnerAccountFromInvoiceCollectionMutationVariables>;

/**
 * __useRemovePartnerAccountFromInvoiceCollectionMutation__
 *
 * To run a mutation, you first call `useRemovePartnerAccountFromInvoiceCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePartnerAccountFromInvoiceCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePartnerAccountFromInvoiceCollectionMutation, { data, loading, error }] = useRemovePartnerAccountFromInvoiceCollectionMutation({
 *   variables: {
 *      invoiceCollectionId: // value for 'invoiceCollectionId'
 *      partnerAccountId: // value for 'partnerAccountId'
 *   },
 * });
 */
export function useRemovePartnerAccountFromInvoiceCollectionMutation(baseOptions?: Apollo.MutationHookOptions<RemovePartnerAccountFromInvoiceCollectionMutation, RemovePartnerAccountFromInvoiceCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePartnerAccountFromInvoiceCollectionMutation, RemovePartnerAccountFromInvoiceCollectionMutationVariables>(RemovePartnerAccountFromInvoiceCollectionDocument, options);
      }
export type RemovePartnerAccountFromInvoiceCollectionMutationHookResult = ReturnType<typeof useRemovePartnerAccountFromInvoiceCollectionMutation>;
export type RemovePartnerAccountFromInvoiceCollectionMutationResult = Apollo.MutationResult<RemovePartnerAccountFromInvoiceCollectionMutation>;
export type RemovePartnerAccountFromInvoiceCollectionMutationOptions = Apollo.BaseMutationOptions<RemovePartnerAccountFromInvoiceCollectionMutation, RemovePartnerAccountFromInvoiceCollectionMutationVariables>;